module.exports = __webpack_public_path__ + "static/img/botton_zuweihui.32375801.png";